import React, { useEffect, useState, useCallback } from "react";
import CategoryComponent from "../../components/HeaderBox";
import "./index.css";
import { useTranslation } from "react-i18next";
import formatDate from "../../components/HeaderBox/formatDate";
import { getBeyondProductLifeCycle46Totals } from "../../../../../apis/Product/BeyondProductLifeCycleFlow46Api";

// Using a simple SVG icon for beyond product life cycle
const BeyondProductLifeCycle46Icon = () => (
  <svg width="76" height="76" viewBox="0 0 76 76" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M38 10L20 25V35C20 45 25 55 38 60C51 55 56 45 56 35V25L38 10Z" stroke="white" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M38 30V50" stroke="white" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M38 20V25" stroke="white" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const BeyondProductLifeCycle46Header = ({
  className,
  leftBoxProps,
  rightBoxProps,
  productId,
  show,
  ...props
}) => {
  const { t } = useTranslation();
  const [totalBeyondProductLifeCycleItem, setTotalBeyondProductLifeCycleItem] = useState(null);

  const fetchTotals = useCallback(() => {
    if (productId) {
      getBeyondProductLifeCycle46Totals({
        productId,
        setTotals: setTotalBeyondProductLifeCycleItem,
      });
    }
  }, [productId]);

  useEffect(() => {
    fetchTotals();
  }, [fetchTotals]);

  // Listen for refresh events from table components
  useEffect(() => {
    const handleRefresh = () => {
      fetchTotals();
    };
    
    window.addEventListener('refresh-beyond-product-life-cycle-46-totals', handleRefresh);
    
    return () => {
      window.removeEventListener('refresh-beyond-product-life-cycle-46-totals', handleRefresh);
    };
  }, [fetchTotals]);

  return (
    <CategoryComponent
      show={show}
      className={`beyond-product-life-cycle-46-category ${className || ""}`}
      leftBoxProps={{
        icon: <BeyondProductLifeCycle46Icon />,
        title: t("BEYOND_PRODUCT_LIFE_CYCLE") || "Beyond product life cycle",
        description:
          t("BEYOND_PRODUCT_LIFE_CYCLE_DESC") ||
          "Reports the environmental benefits or burdens from materials or energy recovered at end-of-life, after recycling or energy recovery. It shows how the recovered outputs may replace new production elsewhere, generating potential \"credits\" or \"debits\" beyond the product's own life cycle.",
        productId: productId,
        isSystemBoundary: true,
        customTextColor: "white",
        ...leftBoxProps,
      }}
      rightBoxProps={{
        totals: [
          {
            title: t("TOTAL_LIFECYCLE_PHASE"),
            items: [
              {
                subtitle: "",
                subitems: [],
              },
            ],
            isSwitchable: true,
          },
          // {
          //   title: t("TOTAL_FOR_FLOW_46") || "Total for Flow 46",
          //   items: [
          //     {
          //       subtitle: "",
          //       subitems: [],
          //     },
          //   ],
          //   isSwitchable: true,
          // },
        ],
        impactTotals: totalBeyondProductLifeCycleItem?.impact_totals || null,
        lastUpdated: totalBeyondProductLifeCycleItem?.updated_at
          ? formatDate(totalBeyondProductLifeCycleItem?.updated_at)
          : t("DD_MM_YYYY"),
        customTextColor: "white",
        ...rightBoxProps,
      }}
      {...props}
    />
  );
};

export default BeyondProductLifeCycle46Header;

